import { CustomLicenseField } from "../helpers/CustomLicenseField";

const RegularField = ({ id, field, readOnly, updateField }) => {

  return tangibleFields.render({
    ...field,
    name: `${id}-${field.name}`,
    readOnly: readOnly,
    onChange: value => {
      if ( value === field.value || value === field.display_value ) return

      const newField = JSON.parse(JSON.stringify(field))
      if ( field.prefix || field.suffix ) {
        newField.display_value = value
        newField.value = value.substring(
          field.prefix ? field.prefix.length : 0,
          value.length - ( field.suffix ? field.suffix.length : 0 )
        )
      } else {
        newField.value = value
      }
      updateField(newField)
    }
  })
}

export const UserFields = ({ id, readOnly, fields, original, updateField, updateLicense }) => {

  return (
    <div className="tgbl-user-accrediting-agencies__list__item__panel__inner__form__user-fields">
      { fields.map((fieldInstance, index) => {
        return fieldInstance.inputMask
          ? <CustomLicenseField
            key={`${id}-${fieldInstance.name}-${original ? 0 : 1}-${readOnly ? 1 : 0}`}
            name={`${id}-${fieldInstance.name}`}
            label={fieldInstance.label}
            prefix={fieldInstance.prefix}
            suffix={fieldInstance.suffix}
            mask={fieldInstance.inputMask}
            value={fieldInstance.value}
            onChange={data => updateLicense(data, index)}
            readOnly={readOnly}
          />
          : <RegularField
            // Adding originalData to key to force rerender when we press cancel or switch edit modes
            // Effective with Tangible Fields (if you don't want to rerender())
            key={`${id}-${fieldInstance.name}-${original ? 0 : 1}-${readOnly ? 1 : 0}`}
            id={id}
            field={fieldInstance}
            readOnly={readOnly}
            updateField={data => updateField(data, index)}
            original={original}
          />
      })}
    </div>
  )
}
